import { AfterViewInit, Directive, ElementRef, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

// copy paste from https://medium.com/allenhwkim/angular-trap-focus-with-in-a-block-79b7572f23c2
@Directive({ standalone: false, selector: '[trapFocus]' })
export class TrapFocusDirective implements AfterViewInit, OnChanges, OnDestroy {
	// biome-ignore lint/complexity/noBannedTypes: suppressed due to migration - should be fixed
	disposer: Function | null = null;

	constructor(private el: ElementRef) {
		// Empty
	}

	ngAfterViewInit() {
		this.trapFocus(this.el.nativeElement);
	}

	ngOnDestroy(): void {
		if (this.disposer != null) {
			this.disposer();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.trapFocus(this.el.nativeElement);
	}

	trapFocus(element) {
		const focusableEls1 = element.querySelectorAll(
			'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select',
		);
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		const focusableEls = Array.from(focusableEls1).filter((el: any) => !el.disabled);
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		const firstFocusableEl: any = focusableEls[0];
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		const lastFocusableEl: any = focusableEls[focusableEls.length - 1];

		if (this.disposer != null) {
			this.disposer();
		}

		let firstTabbing = true;

		function handleKeydown(e) {
			var isTabPressed = e.keyCode === 9; // isTabPressed
			if (!isTabPressed) return;

			if (e.shiftKey) {
				/* shift + tab */ if (document.activeElement === firstFocusableEl || firstTabbing) {
					lastFocusableEl.focus();
					e.preventDefault();
					firstTabbing = false;
				}
			} /* tab */ else {
				if (document.activeElement === lastFocusableEl || firstTabbing) {
					firstFocusableEl.focus();
					e.preventDefault();
					firstTabbing = false;
				}
			}
		}

		document.addEventListener('keydown', handleKeydown);

		this.disposer = () => document.removeEventListener('keydown', handleKeydown);
	}
}
